export const sapFiori3DarkParameters = {};
